/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFitnessChallengeTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFitnessChallenge,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Get Fit Together!",
    "Challenge Accepted!",
    "Let’s Get Moving!",
  ],
  title: "Fitness Challenge",
  description: "Organize a fun fitness challenge.",
  longDescription:
    "Gather your friends for an exciting fitness challenge! Choose a date, decide on activities, and set goals to achieve together!",
  emoji: "🏋",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Fitness Challenge",
          emoji: "🏋",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we start the fitness challenge?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities for the challenge?",
            description:
              "What activities should we include in our fitness challenge?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we do?",
                emoji: "🏃",
                completeAction: {
                  question: "Decide on goals to achieve?",
                  description:
                    "What fitness goals should we set for the challenge?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What goals should we aim for?",
                      emoji: "🏆",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Fit Together!",
    outroDescription:
      "Your fitness challenge plans are set! Enjoy the journey to better health!",
  },
};
